/** Ignore stale servers/rollbacks and malformed version values. */
export function isNewerRelease(current: string, available: string): boolean {
  if (!/^\d+\.\d+\.\d+$/.test(current) || !/^\d+\.\d+\.\d+$/.test(available)) return false;
  const left = current.split(".").map(Number);
  const right = available.split(".").map(Number);
  for (let index = 0; index < 3; index++) {
    if (left[index] !== right[index]) return right[index]! > left[index]!;
  }
  return false;
}

export function prepareBrowserRefresh(current: string, available: string, href: string, storage: Pick<Storage, "getItem" | "setItem">): string | null {
  if (!isNewerRelease(current, available)) return null;
  const key = `link:version-refresh:${available}`;
  try {
    if (storage.getItem(key) === "1") return null;
    const url = new URL(href);
    url.searchParams.set("link_version", available);
    storage.setItem(key, "1");
    return url.toString();
  } catch { return null; } // Without a durable loop guard, don't risk repeated refreshes.
}
